import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';

import AppNavigator from './AppNavigator';

import config from 'common/config/config';
import { store, persistor } from 'common/redux/store';
import { PersistGate } from 'redux-persist/integration/react';

import Bugsnag from 'common/libs/bugsnag';
import ErrorBoundary from 'common/libs/errorBoundary';

import { DRNContainer } from '@traveloka/district-ui';
import NavigationService from 'common/libs/react-navigation/NavigationService';
import DefaultStatusBar from 'common/components/DefaultStatusBar/DefaultStatusBar';
import Auth, { AuthContext } from 'common/libs/AuthZero/Auth';
import CognitoAuthProvider from 'common/libs/Cognito/Auth.web';
import { isCognitoEnabled } from 'common/constants/featureFlag';

Amplify.configure(config.amplify);

const auth = new Auth();

const AuthProvider = isCognitoEnabled
  ? CognitoAuthProvider
  : AuthContext.Provider;

export default class AppRoot extends Component {
  render() {
    return (
      <Bugsnag>
        <DefaultStatusBar />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
              <DRNContainer>
                <AuthProvider value={auth}>
                  <AppNavigator
                    navigatorRef={navigator =>
                      NavigationService.setTopLevelNavigator(navigator)
                    }
                  />
                </AuthProvider>
              </DRNContainer>
            </ErrorBoundary>
          </PersistGate>
        </Provider>
      </Bugsnag>
    );
  }
}
